// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.prof-modal-submit-btns__cont[data-v-18d0a677] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: auto;\n  margin-top: 30px;\n  margin-left: auto;\n}\n.prof-modal-submit-btns__btn[data-v-18d0a677] {\n  display: inline-block;\n  width: auto;\n  padding: 0 25px;\n}\n.prof-modal-submit-btns__btn[data-v-18d0a677]:first-of-type {\n  margin-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
